import { render } from "./Avaliar.vue?vue&type=template&id=2167dd44&scoped=true"
import script from "./Avaliar.vue?vue&type=script&lang=js"
export * from "./Avaliar.vue?vue&type=script&lang=js"

import "./Avaliar.vue?vue&type=style&index=0&id=2167dd44&scoped=true&lang=css"
import "./Avaliar.vue?vue&type=style&index=1&id=2167dd44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2167dd44"]])

export default __exports__